import type { LightweightUser } from 'src/v3/manage/manage.slice'

export interface UserRow {
  id: string
  name: string
  firstName: string
  lastName: string
  primaryEmail: string
  licenseTypes: string[]
}

export function transformUsersToRows(users: LightweightUser[]): UserRow[] {
  return users.map((user) => ({
    id: user.id,
    name: `${user.firstName} ${user.lastName}`,
    firstName: user.firstName,
    lastName: user.lastName,
    primaryEmail: user.primaryEmail,
    licenseTypes: user.licenseTypes || [],
  }))
}

export function extractLicenseTypes(userRows: UserRow[]): string[] {
  let licenseTypesSet = new Set<string>()
  userRows.forEach((user) => {
    user.licenseTypes?.forEach((lt) => licenseTypesSet.add(lt))
  })
  return Array.from(licenseTypesSet).toSorted((a, b) => a.localeCompare(b))
}

export function filterUsers(
  users: UserRow[],
  selectedUsers: string[],
  licenseTypeFilter: string,
  searchQuery: string,
): UserRow[] {
  let query = searchQuery.toLowerCase()
  let selectedSet = new Set(selectedUsers)

  return users.filter((user) => {
    // Always include selected users
    if (selectedSet.has(user.id)) return true

    // Apply license type filter to non-selected users
    if (licenseTypeFilter && !user.licenseTypes?.includes(licenseTypeFilter)) {
      return false
    }

    // Apply search filter to non-selected users
    if (searchQuery) {
      let matchesName = user.name.toLowerCase().includes(query)
      let matchesEmail = user.primaryEmail.toLowerCase().includes(query)

      if (!matchesName && !matchesEmail) return false
    }

    return true
  })
}
